import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http'
import {inject} from '@angular/core'
import {Observable, throwError} from 'rxjs'
import {catchError} from 'rxjs/operators'
import {ResponseErrorHelperService} from './error-dialog/response-error-helper.service'

/**
 * Intended to catch e.g. 401 responses and if so re-route to home.
 */
export const responseInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const errorHelper = inject(ResponseErrorHelperService)
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      errorHelper.handleError(req, error)
      return throwError(() => error)
    })
  )
}